import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const query = location.search || "";
    const hash = location.hash || "";
    trackPageView(`${location.pathname}${query}${hash}`);
  }, [location.pathname, location.search, location.hash]);

  return null;
};

export default RouteTracker;
